import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class SolicitudesAfiliacion extends ApiGenericServicesData {
    constructor() {
        super("hojasAfiliacionYAdhesion");
    }

    async getHojasList(idOp, faseOp) {
        const idOpSeguro = await codificarValorSeguro(idOp);
        const faseOpSegura = await codificarValorSeguro(faseOp);
        return this.customGET("list/"+ idOpSeguro + "/" + faseOpSegura)
    }

    async guardarAfiliado(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("create/", dataSegura);
    }

    async eliminarHojadePaquete(idDetalle, idHoja) {
        const idDetalleSeguro = await codificarValorSeguro(idDetalle);
        const idHojaSeguro = await codificarValorSeguro(idHoja);
        return this.customPOST("delete/" + idDetalleSeguro + "/" + idHojaSeguro);
    }

    async actualizarAfiliado(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("update/", dataSegura);
    }

    async consultarHoja(idOp, faseOp, correlativo) {
        const idOpSeguro = await codificarValorSeguro(idOp);
        const faseOpSegura = await codificarValorSeguro(faseOp);
        const correlativoSeguro = await codificarValorSeguro(correlativo);
        return this.customGET("consultar/" + idOpSeguro + "/" + faseOpSegura + "/" + correlativoSeguro );
    }

    async verificarCUI(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("verificar", dataSegura)
    }

}
